import { createSlice, createSelector } from '@reduxjs/toolkit';

const userRoleSlice = createSlice({
    name: 'userRole',
    initialState: {
        isLoading: false,
        ISLOADING: false,
        userRoleData: [],
        updateRoleResponseData: [],
        userData: [],
        singleUserData: null,
        pageSize: 10,
        pageIndex: 1,
        loaderMessage: '',
        filterData: {},
        successMessage: '',
        errorMessage: ''
    },

    reducers: {
        startUserRoleDataFetch(state, action) {
            state.isLoading = true;
            state.loaderMessage = 'Loading user roles...';
        },
        setUserRoleDataSuccess(state, action) {
            state.isLoading = false;
            state.userRoleData = action.payload;
            state.loaderMessage = '';
        },
        setUserRoleDataError(state, action) {
            state.isLoading = false;
            state.errorMessage = action.payload;
            state.loaderMessage = '';
        },
        startUserDataFetch(state, action) {
            state.isLoading = true;
            state.loaderMessage = 'Loading users...';
            if (action.payload?.pageIndex) state.pageIndex = action.payload.pageIndex;
            if (action.payload?.pageSize) state.pageSize = action.payload.pageSize;
        },
        setUserDataSuccess(state, action) {
            state.isLoading = false;
            state.userData = action.payload;
            state.loaderMessage = '';
        },
        setUserDataError(state, action) {
            state.isLoading = false;
            state.errorMessage = action.payload;
            state.loaderMessage = '';
        },
        startFetchSingleUser(state, action) {
            state.isLoading = true;
            state.loaderMessage = 'Loading user details...';
        },
        setSingleUserData(state, action) {
            state.isLoading = false;
            state.singleUserData = action.payload;
            state.loaderMessage = '';
        },
        startAddUserFetch(state, action) {
            state.isLoading = true;
            state.loaderMessage = 'Adding user...';
        },
        setAddUserSuccess(state, action) {
            state.isLoading = false;
            state.successMessage = 'User added successfully!';
            state.userData = [...state.userData, action.payload];
            state.loaderMessage = '';
        },
        setAddUserError(state, action) {
            state.isLoading = false;
            state.errorMessage = action.payload;
            state.loaderMessage = '';
        },
        startUpdateUserFetch(state, action) {
            state.isLoading = true;
            state.loaderMessage = 'Updating user...';
        },
        setUpdateUserSuccess(state, action) {
            state.isLoading = false;
            state.successMessage = 'User updated successfully!';
            state.userData = state.userData.map((user) => (user.id === action.payload.id ? action.payload : user));
            state.singleUserData = Array.isArray(action.payload) ? action.payload[0] : action.payload;
            state.loaderMessage = '';
        },
        clearSingleUserData: (state) => {
            state.singleUserData = null;
        },
        setUpdateUserError(state, action) {
            state.isLoading = false;
            state.errorMessage = action.payload;
            state.loaderMessage = '';
        },
        startDeleteUserFetch(state, action) {
            state.isLoading = true;
            state.loaderMessage = 'Deleting user...';
        },
        setDeleteUserSuccess(state, action) {
            state.isLoading = false;
            state.successMessage = 'User deleted successfully!';
            state.userData = state.userData.filter((user) => user.id !== action.payload);
            state.loaderMessage = '';
        },
        setDeleteUserError(state, action) {
            state.isLoading = false;
            state.errorMessage = action.payload;
            state.loaderMessage = '';
        },
        setFilterData(state, action) {
            state.filterData = action.payload;
        },
        clearMessages(state) {
            state.successMessage = '';
            state.errorMessage = '';
        },
        updateUserRole(state, action){
            state.ISLOADING = true;
        },
        setUpdateUserRole(state, action){
            state.updateRoleResponseData = action.payload;
        },
        completedFetch(state, action){
            state.ISLOADING = false;
        }
    }
});

export const {
    startUserRoleDataFetch,
    setUserRoleDataSuccess,
    setUserRoleDataError,
    startUserDataFetch,
    setUserDataSuccess,
    setUserDataError,
    startFetchSingleUser,
    setSingleUserData,
    startAddUserFetch,
    setAddUserSuccess,
    setAddUserError,
    startUpdateUserFetch,
    setUpdateUserSuccess,
    setUpdateUserError,
    startDeleteUserFetch,
    setDeleteUserSuccess,
    setDeleteUserError,
    setFilterData,
    clearMessages,
    clearSingleUserData,
    updateUserRole,
    setUpdateUserRole,
    completedFetch
} = userRoleSlice.actions;

export default userRoleSlice.reducer;

// Selectors
const mainUserRoleDataState = (state) =>
    state?.userRole || {
        isLoading: false,
        userRoleData: [],
        userData: [],
        singleUserData: null,
        pageSize: 10,
        pageIndex: 1,
        loaderMessage: '',
        filterData: {},
        successMessage: '',
        errorMessage: ''
    };

export const userRoleDataSelector = createSelector(mainUserRoleDataState, (state) => state.userRoleData || []);

export const userDataSelector = createSelector(mainUserRoleDataState, (state) => state.userData || []);

export const singleUserDataSelector = createSelector(mainUserRoleDataState, (state) => state.singleUserData);

export const isLoadingSelectorUserRole = createSelector(mainUserRoleDataState, (state) => state.isLoading);

export const roleUpdateSelector = createSelector(mainUserRoleDataState, (state) => state.ISLOADING);

export const loaderMessageSelectorUserRole = createSelector(mainUserRoleDataState, (state) => state.loaderMessage);

export const successMessageSelectorUserRole = createSelector(mainUserRoleDataState, (state) => state.successMessage);

export const errorMessageSelectorUserRole = createSelector(mainUserRoleDataState, (state) => state.errorMessage);

export const filterDataSelectorUserRole = createSelector(mainUserRoleDataState, (state) => state.filterData);

export const pageIndexSelectorUserRole = createSelector(mainUserRoleDataState, (state) => state.pageIndex);

export const pageSizeSelectorUserRole = createSelector(mainUserRoleDataState, (state) => state.pageSize);
